<template>
  <main class="mx-auto py-8 overflow-x-hidden sustainability-index-page">

    <common-breadcrumb
      class="sustainability__breadcrumbs breadcrumbs overflow-hidden d-block text-truncate container mb-8 mt-xl-8 mb-xl-16"
      :crumbs="breadCrumbs"
    />
    <div
      class="sustainability__banner d-flex flex-column justify-content-center"
      :style="{
        'background-image': `url(${sustainabilityPage.headerCoverImage.url})`,
      }"
    >
      <div class="sustainability__banner__content container">
        <div class="row text-left">
          <div class="col-lg-8 col-12">
            <div class="px-xl-12">
              <h1 class="p-0">{{ sustainabilityPage.headline }}</h1>
              {{ sustainabilityPage.headerText }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <main class="overflow-x-hidden">
      <strapi-sustainability-page-components
        v-if="sustainabilityPage.content != null"
        :contents="sustainabilityPage.content"
      />
    </main>
  </main>
</template>

<script setup lang="ts">
import type {BreadCrumb} from '../common/types';
import useSustainabilityPage from '~/components/sustainability/features/useSustainabilityPage';

const {t} = useI18n();
const breadCrumbs = ref<Array<BreadCrumb>>([
  {
    title: t('general/menu/item/sustainability') as string,
    link: 'sustainability',
  },
]);

const {sustainabilityPage} = await useSustainabilityPage();
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/mixins/breakpoints';
@import 'gportal-theme/scss/breakpoints.scss';

.sustainability {

  &__banner {
    background: transparent linear-gradient(90deg, #31243ccc 0%, #40244eb0 54%, #9b27be00 100%) 0% 0% no-repeat padding-box;
    background-size: cover;
    background-position-y: center;
    min-height: 300px;
    &__content {
      @include media-breakpoint-down(md) {
        padding: 2em;
      }
      height: fit-content;
    }
  }
}
</style>
